import { TextField as MuiTextField, TextFieldProps } from '@mui/material';
import React from 'react'

type IProps = TextFieldProps & { controlled?: boolean };

const TextField: React.FC<IProps> = (props) => {
    const { controlled, ...rest } = props;

    return (
        <>
            <MuiTextField variant='outlined' {...rest} color='primary' />
            {/* <FormControl variant='outlined' fullWidth>
                <InputLabel>{label}</InputLabel>
                <OutlinedInput {...rest} />
            </FormControl> */}
        </>
    )
}

export default TextField;